// ───────────────────────────────────────────────────
// src/features/stock/components/ProductManagement.tsx
// ───────────────────────────────────────────────────
import React, { useState } from 'react';
import Tabs from '../../../../shared/components/ui/Tabs';
import AddModifyProduct from './AddModifyProduct';
import AttributesManagement from './AttributesManagement';
import StockManagment from './StockManagment';

const subTabLabels = ['Add/Modify Product', 'Attributes', 'Stock'];

export default function ProductManagement() {
  const [activeSubTab, setActiveSubTab] = useState<string>(subTabLabels[0]);

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-neutral-100">Product Management</h2>

      {/* ─── Sub-tab Bar ───────────────────────────────────────────────────────── */}
      <Tabs
        tabs={subTabLabels}
        activeTab={activeSubTab}
        onTabChange={setActiveSubTab}
      />

      {/* ─── Add / Modify Product ─────────────────────────────────────────────── */}
      {activeSubTab === subTabLabels[0] && (
        <div className="bg-neutral-900 p-4 rounded-md">
          <AddModifyProduct />
        </div>
      )}

      {/* ─── Attributes ───────────────────────────────────────────────────────── */}
      {activeSubTab === subTabLabels[1] && (
        <div className="bg-neutral-900 p-4 rounded-md">
          <AttributesManagement />
        </div>
      )}

      {/* ─── Stock ─────────────────────────────────────────────────────────────── */}
      {activeSubTab === subTabLabels[2] && (
        <div className="bg-neutral-900 p-4 rounded-md">
          <StockManagment />
        </div>
      )}
    </div>
  );
}
